import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/CommonStyle.css";
import "../css/Home.css";
import Header from "./Header";
import ic_toyota from "../img/ic_toyota_main_category.png";
import ic_nissan from "../img/ic_nissan_main_category.png";
import ic_mitsubishi from "../img/ic_mitsubishi_main_category.png";
import ic_honda from "../img/ic_honda_main_category.png";
import ic_provider_1 from "../img/ic_provider_1.png";
import ic_provider_2 from "../img/ic_provider_2.png";
import ic_provider_3 from "../img/ic_provider_3.png";
import ic_provider_4 from "../img/ic_provider_4.png";
import ic_provider_5 from "../img/ic_provider_5.png";
import ic_provider_6 from "../img/ic_provider_6.png";
import ic_provider_7 from "../img/ic_provider_7.png";
import ic_provider_8 from "../img/ic_provider_8.png";
import ic_provider_9 from "../img/ic_provider_9.png";
import ic_provider_10 from "../img/ic_provider_10.png";
import ic_provider_11 from "../img/ic_provider_11.png";
import ic_provider_12 from "../img/ic_provider_12.png";
import ic_provider_13 from "../img/ic_provider_13.png";
import ic_provider_14 from "../img/ic_provider_14.png";
import ic_provider_15 from "../img/ic_provider_15.png";
import 'animate.css';
import FullPageLoadingLayout from "./FullPageLoadingLayout";
import axios from "axios";
import ic_search from "../img/ic_search_header.png";
import ic_view_categories from "../img/ic_view_categories.png";
import ic_view_brands from "../img/ic_view_brands.png";
import ic_continue_arrow from "../img/ic_continue_arrow.png";
import ic_continue_blue_arrow from "../img/ic_continue_blue_arrow.png";
import ic_drop_down from "../img/ic_down_dropdown.png";
import ic_collapse from "../img/ic_collapse.png";
import ic_select_all from "../img/ic_select_all.png";
import ic_deselect_all from "../img/ic_deselect_all.png";
import ic_not_selected_all from "../img/ic_not_selected_all.png";
import header_bg from "../img/finder.jpg";
import dropdown_header from "../img/arrow.png";
import ic_search_white_icon from "../img/search_white_icon.svg";
import brand_1 from "../img/br1.png";
import brand_2 from "../img/br2.png";
import brand_3 from "../img/br3.png";
import brand_4 from "../img/br4.png";
import brand_5 from "../img/br5.png";
import brand_6 from "../img/br6.png";
import brand_7 from "../img/br7.png";
import brand_8 from "../img/br8.png";
import ytm from "../img/yt_mirror.png";
import rbi from "../img/rbi.png";
import krc from "../img/krc_original_logo.png";
import ic_arrow from "../img/arrow.png";

function Home() {

    const [showHideCategoryDropDown, setShowHideCategoryDropDown] = useState(false)
    const [showHideSubCategoryDropDown, setShowHideSubCategoryDropDown] = useState(false)
    const [showHidemakeDropDown, setShowHideMakeDropDown] = useState(false)
    const [showHideModelDropDown, setShowHideModelDropDown] = useState(false)

    const [subCategoryNameList, setSubCategoryNameList] = useState(null)
    const [categoryNameList, setCategoryNameList] = useState(null)
    const [modelNamesOfAMakeList, setModelNamesOfAMakeList] = useState(null)
    const [categoryForDropDown, setCategoryForDropDown] = useState(null)
    const [subCategoryForDropDown, setSubCategoryForDropDown] = useState(null)
    const [makeNameForDropDown, setMakeNameForDropDown] = useState(null)
    const [modelNameForDropDown, setModelNameForDropDown] = useState(null)
    const [keywordForDropDown, setKeywordForDropDown] = useState(null)

    const [makeNameList, setMakeNameList] = useState(null)

    const navigate = useNavigate();

    // sorting fn
    const applyCustomOrder = (arr, desiredOrder) => {
        const orderForIndexVals = desiredOrder.slice(0).reverse();
        arr.sort((a, b) => {
            const aIndex = -orderForIndexVals.indexOf(a.Make?.trim()?.toUpperCase());
            const bIndex = -orderForIndexVals.indexOf(b.Make?.trim()?.toUpperCase());
            return aIndex - bIndex;
        });
    }


    const callAPIToGetMakeNames = () => {

        // previously i called https://cubixweberp.com:173/api/InventMasters/InventoryLevel1?cmpcode=AUTOLAND&guid=F285D054-3200-4413-A624-DAD26D8A5616&mod=SEARCH_ITEMS&lvl1=ALL&lvl2=ALL&lvl3=ALL&lvl4=ALL&lvl5=ALL&searchKey=${searchtext}
        // but by calling this also getting,

        axios.get('https://cubixweberp.com:197/api/InventMasters/InventoryLevel1?cmpcode=AUTOLAND&guid=C406671E-B36F-4D24-B0D2-04D129936FBE&mod=LEVEL1').then((res) => {

            let sortOrder = ['TOYOTA', 'NISSAN', 'MITSUBSHI', 'SUZUKI', 'MAZDA', 'HONDA', 'HYUNDAI'];   // Declare a array that defines the order of the elements to be sorted.


            console.log("sorted order 2 ", applyCustomOrder(res.data, sortOrder))

            setMakeNameList(res.data)
            localStorage.setItem("autoland_make_array", JSON.stringify(res.data))
        }).catch((err) => {
            console.log("err ", err)
        })
    }

    const setYearListToLocalStorage = () => {

        const year = (new Date()).getFullYear();

        let yearArray = Array.from(new Array(50), (val, index) => {
            return { yearName: year - index }
        });

        console.log(" yearArray ", yearArray)
        let mappedYearArray = yearArray.map((item) => {
            return { ...item, is_selected: false }
        })

        localStorage.setItem("autoland_year_array", JSON.stringify(mappedYearArray))
    }


    useEffect(() => {

        callAPIToGetMakeNames()
        setYearListToLocalStorage()
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);

    }, [])

    const clickedOnCategoryDropDown = (categoryFromClick) => {

        console.log(" categoryFromClick name ", categoryFromClick)
        setCategoryForDropDown(categoryFromClick)
        setSubCategoryForDropDown(null)
    }


    const clickedOnSubCategoryDropDown = (subCategoryFromClick) => {

        console.log(" subcategoryFromClick name ", subCategoryFromClick)
        setSubCategoryForDropDown(subCategoryFromClick)
    }

    const clickedOnMakeDropDown = (makeNameFromClick) => {

        console.log(" makeNameFromClick name ", makeNameFromClick)
        setMakeNameForDropDown(makeNameFromClick)
        setModelNameForDropDown(null)
    }

    const clickedOnModelDropDown = (modelNameFromClick) => {

        console.log(" makeNameFromClick name ", modelNameFromClick)
        setModelNameForDropDown(modelNameFromClick)
    }

    const handleKeyWordInput = (e) => {

        setKeywordForDropDown(e.target.value)
    }

    const clickedOnSearchButton = () => {

        if (makeNameForDropDown == null && modelNameForDropDown == null && categoryForDropDown && null || subCategoryForDropDown && null || keywordForDropDown && null) {
            alert("please select values and search")
        } else {
            let makeToSend = makeNameForDropDown ? makeNameForDropDown : "ALL"
            let modelToSend = modelNameForDropDown ? modelNameForDropDown : "ALL"
            let categoryToSend = categoryForDropDown ? categoryForDropDown : "ALL"
            let subCategoryToSend = subCategoryForDropDown ? subCategoryForDropDown : "ALL"
            let keyWordToSend = keywordForDropDown ? keywordForDropDown : "ALL"

            navigate(`/show_parts_list?makename=${makeToSend}&modelname=${modelToSend}&modelyear=${"2024"}&maincategory=${categoryToSend}&subcategory=${subCategoryToSend}&searchkey=${keyWordToSend}`)
        }

    }

    const clickedOnMakeCheckbox = (makeNameFromClick) => {
        navigate(`/show_models?makename=${makeNameFromClick}`)

    }

    const callAPIToGetModelNames = (makeNameForGettingModel) => {

        axios.get(`https://cubixweberp.com:197/api/InventMasters/InventoryLevel2?cmpcode=AUTOLAND&guid=C406671E-B36F-4D24-B0D2-04D129936FBE&mod=LEVEL2&lvl1=${makeNameForGettingModel}`).then((res) => {
            setModelNamesOfAMakeList(res.data)
        }).catch((err) => {
            console.log("err ", err)
        })
    }

    useEffect(() => {
        callAPIToGetModelNames(makeNameForDropDown)
    }, [makeNameForDropDown])

    const groupMainCategory = (tech) => {


        const groupedTech = Object.entries(
            // What you have done
            tech.reduce((acc, { group, GroupDesc, MainCatergory }) => {
                // Group initialization
                if (!acc[MainCatergory]) {
                    acc[MainCatergory] = [];
                }

                // Grouping
                // FIX: only pushing the object that contains id and value
                acc[MainCatergory].push({ group, MainCatergory });

                return acc;
            }, {})
        ).map(([label, options]) => ({ label, options }));

        console.log("groupedTech ", groupedTech);

        localStorage.setItem("autoland_group_and_subgroup", JSON.stringify(groupedTech))
        setCategoryNameList(groupedTech)
    }

    const callAPIToGetCategoryNames = () => {

        axios.get('https://cubixweberp.com:197/api/InventMasters/InventoryLevel4?cmpcode=AUTOLAND&guid=82D38C38-65BF-46AF-8871-D8219757842C&mod=LEVEL4&lvl1=A1&lvl2=A2&lvl3=A3').then((res) => {

            groupMainCategory(res.data)

        }).catch((err) => {
            console.log("err ", err)
        })
    }

    useEffect(() => {
        callAPIToGetCategoryNames()
    }, [])

    const arrangeSubCategoryList = () => {

        const filteredArray = categoryNameList?.filter((itemForFilter) => {
            return itemForFilter.label == categoryForDropDown
        })
        console.log("filteredArray subcategory", filteredArray)
        if (filteredArray != null) {
            setSubCategoryNameList(filteredArray[0]?.options)
        } else {
            setSubCategoryNameList(null)
        }

    }

    useEffect(() => {

        arrangeSubCategoryList()

    }, [categoryForDropDown])

    const toggleCategoryDropDown = () => {
        console.log("toggleCategoryDropDown clicked ")
        setShowHideCategoryDropDown(prev => !prev)
    }

    const toggleSubCategoryDropDown = () => {
        setShowHideSubCategoryDropDown(prev => !prev)
    }


    const toggleMakeDropDown = () => {
        setShowHideMakeDropDown(prev => !prev)
    }


    const toggleModelDropDown = () => {
        setShowHideModelDropDown(prev => !prev)
    }

    useEffect(() => {

        console.log(" showHideCategoryDropDown ",
            showHideCategoryDropDown,
            showHideSubCategoryDropDown,
            showHidemakeDropDown,
            showHideModelDropDown,
        )

    }, [showHideCategoryDropDown, showHideSubCategoryDropDown,
        showHidemakeDropDown,
        showHideModelDropDown,])



    return (
        <div className="Home-root-container common_page_bg pb-4">

            <div className="Header-wrapper">
                <Header />
            </div>


            <div className="body_bg">
                <div className="position-relative search-dropdown-container">

                    <img className="w-100 Search_image_bg_header" src={header_bg} />

                    <div className="Home-header-search-bar position-absolute top-0 px-4">
                        <h5 className="Search_panel_header-text">Find Parts For Your Vehicle</h5>
                        <div className="Home-search-panel">

                            <span className="Home-dropdown-name-and-list-container">
                                <button className="btn btn-light Home-search-button-dropdown" onClick={() => toggleMakeDropDown()}> <span>{makeNameForDropDown != null ? makeNameForDropDown : "Make"} </span>  <img src={dropdown_header} /> </button>

                                {
                                    showHidemakeDropDown &&
                                    <div className="Home-dropdown-container">
                                        {
                                            makeNameList?.filter((itemMake) => itemMake.Make != "KORO" && itemMake.Make != "LAND CRUISER").map((item, index) => {
                                                return (
                                                    <div className="Home_dropdown_single_item" onClick={(e) => { clickedOnMakeDropDown(item.Make); toggleMakeDropDown(); e.preventDefault() }}>

                                                        <div class="checkbox-wrapper-21 " >

                                                            <label className="make_selection_clickable Home-make-card"  >

                                                                <span >
                                                                    {item.Make}
                                                                </span>

                                                            </label>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }


                                    </div>
                                }

                            </span>

                            <span className="Home-dropdown-name-and-list-container">
                                <button className="btn btn-light Home-search-button-dropdown" onClick={() => toggleModelDropDown()}> <span>{modelNameForDropDown != null ? modelNameForDropDown : "Model"} </span> <img src={dropdown_header} /> </button>
                                {
                                    showHideModelDropDown &&

                                    <div className="Home-dropdown-container">
                                        {
                                            modelNamesOfAMakeList?.length != 0 ? modelNamesOfAMakeList.map((item, index) => {
                                                return (
                                                    <div className="Home_dropdown_single_item" onClick={(e) => { clickedOnModelDropDown(item.Model); toggleModelDropDown(); e.preventDefault() }}>

                                                        <div class="checkbox-wrapper-21" >

                                                            <label className="make_selection_clickable Home-make-card"  >

                                                                <span >
                                                                    {item.Model}
                                                                </span>

                                                            </label>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                                :
                                                <div className="p-2">please select make</div>
                                        }

                                        {
                                            console.log("modelNamesOfAMakeList ", modelNamesOfAMakeList)
                                        }
                                        {
                                            modelNamesOfAMakeList == null && <div >please select make</div>
                                        }
                                    </div>
                                }

                            </span>
                            
                            <span className="Home-dropdown-name-and-list-container">
                                <button className="btn btn-light Home-search-button-dropdown" onClick={() => toggleCategoryDropDown()}> <span> {categoryForDropDown != null ? categoryForDropDown : "Category"}</span>  <img src={dropdown_header} /> </button>
                                {
                                    showHideCategoryDropDown &&
                                    <div className="Home-dropdown-container">
                                        {
                                            categoryNameList?.map((item, index) => {
                                                return (
                                                    <div onClick={(e) => { clickedOnCategoryDropDown(item.label); toggleCategoryDropDown(); e.preventDefault() }}>

                                                        <div className="Home_dropdown_single_item">

                                                            <div >

                                                                <label className="make_selection_clickable Home-make-card"  >

                                                                    <span >
                                                                        {item.label}
                                                                    </span>

                                                                </label>
                                                            </div>

                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </span>

                            <span className="Home-dropdown-name-and-list-container">
                                <button className="btn btn-light Home-search-button-dropdown" onClick={() => toggleSubCategoryDropDown()} > <span>{subCategoryForDropDown != null ? subCategoryForDropDown : "Sub Category"}</span> <img src={dropdown_header} /> </button>
                                {
                                    showHideSubCategoryDropDown &&

                                    <div className="Home-dropdown-container">
                                        {
                                            subCategoryNameList?.map((item, index) => {
                                                return (
                                                    <div className="Home_make_model_card" onClick={(e) => { clickedOnSubCategoryDropDown(item.group); toggleSubCategoryDropDown(); e.preventDefault() }}>

                                                        <div className="Home_dropdown_single_item">

                                                            <div class="checkbox-wrapper-21 " >

                                                                <label className="make_selection_clickable Home-make-card"  >

                                                                    <span >
                                                                        {item.group}
                                                                    </span>

                                                                </label>
                                                            </div>

                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            subCategoryNameList == null && <div className="p-2">please select category</div>
                                        }
                                    </div>
                                }
                            </span>




                            {/* <input className="Header-search-box" placeholder="Enter Keyword or Part Number" onChange={(e) => handleKeyWordInput(e)} /> */}
                            <button className="Header-search-text-button" onClick={() => clickedOnSearchButton()} >Search</button>

                        </div>
                    </div>
                </div>

                <div className="container Home_section_label">

                    <div className="heading_ribbon_container_outer mt-4">
                        <div className="heading_ribbon_container">
                            <h4>SELECT MAKE</h4>
                        </div>
                    </div>

                </div>

                <div className="container Home_make_model_container mt-4 py-4">


                    <div className="make_model_container">
                        {
                            makeNameList?.filter((itemMake) => itemMake.Make != "KORO" && itemMake.Make != "LAND CRUISER").map((item, index) => {
                                return (
                                    <div key={item.Make} className="Home_make_model_card" onClick={(e) => { clickedOnMakeCheckbox(item.Make); e.preventDefault() }}>

                                        <div className="Home_make_model_auto_height_card">

                                            <div class="Home_logo_wrapper" >

                                                <label className="make_selection_clickable Home-make-card"  >



                                                    <img className="make_logo me-2" onError={(e) => {
                                                        e.target.src = 'ic_no_image_found.svg';
                                                    }} src={`http://autoland1.fortiddns.com:83/make/${item.Make.replace(/ +/g, "").trim()}.svg`} />


                                                    {/* 
                                                    <span >
                                                        {item.Make}
                                                    </span> */}

                                                </label>
                                            </div>

                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>

                </div>


                <div className="container Home_section_label">

                    <div className="heading_ribbon_container_outer mt-4">
                        <div className="heading_ribbon_container">
                            <h4>BRANDS WE DEAL WITH</h4>
                        </div>
                    </div>

                </div>

                <div className="brands_we_deal_container container mt-3">


                    <div>
                        <img src={brand_2} />
                    </div>
                    <div>
                        <img src={brand_1} />
                    </div>
                    <div>
                        <img src={brand_4} />
                    </div>
                    <div>
                        <img src={brand_6} />

                    </div>
                    <div>
                        <img src={brand_8} />
                    </div>
                    <div>
                        <img src={ytm} />
                    </div>
                    <div>
                        <img src={brand_5} />
                    </div>




                    <div>
                        <img src={rbi} />
                    </div>
                    <div>
                        <img src={krc} />
                    </div>
                    <div>
                        <img src={brand_3} />
                    </div>



                    <div>
                        <img src={brand_7} />
                    </div>

                </div>


            </div>

        </div >
    )
}

export default Home;